import { isInGroup } from '@frontend/utils';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { fabric } from 'fabric';
import { getGroupNameByAddFieldId } from "@/common/preview/draw-smart-object";
import { FIELD_TYPE_SMART_OBJECT } from "@frontend/constants/type-fields-of-template";

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

export function drawMarker({ fields, data, canvas, id, group_fields, dimension }) {
  canvas.getObjects().forEach(function (o) {
    if (o.id === "circle" || o.id === "square" || o.id === "list") {
      canvas.remove(o);
    }
  });

  const { canvas_data } = getScopePage();
  
  const list_type = data["list_type"];
  
  fields.forEach((field) => {
    const options = JSON.parse(field.options);
    const groupName = getGroupNameByAddFieldId(
      String(field.id),
      canvas_data[id]
    );
    const visible = !options['Hidden'];

    if (
      field.type === "List Numbered Circle" ||
      field.type === "List Checkmark" ||
      field.type === "List Star" ||
      ((list_type === "circle" ||
          list_type === "checkmark" ||
          list_type === "star") &&
        field.type === "List All" &&
        (!group_fields || isInGroup(group_fields, field.name)))
    ) {
      const circle = new fabric.Circle({
        id: "circle",
        groupName: groupName,
        order: parseInt(options["Order"]),
        top: parseInt(options["Y"]),
        left: canvas_data[id].spacingFieldPosition[field.name]
          ? canvas_data[id].spacingFieldPosition[field.name].x
          : parseInt(options["X"]),
        radius: parseInt(options["Width"]) / 2,
        stroke: "#ffffff",
        strokeWidth: 10,
        fill: "rgba(0,0,0,0)",
        selectable: false,
        evented: false,
        visible
      });
      let group_x = 0;
      let group_y = 0;
      
      if (groupName && canvas_data[id].smartObjCoords[groupName]) {
        group_y = parseInt(canvas_data[id].smartObjCoords[groupName]["Y"]);
        group_x = parseInt(canvas_data[id].smartObjCoords[groupName]["X"]);
      }
      circle.set({
        left: circle.left + group_x - dimension[2] + dimension[4].x,
        top: circle.top + group_y - dimension[3] + dimension[4].y,
      });
      
      canvas.add(circle);
    } else if (
      field.type === "List Numbered Square" ||
      (list_type === "square" &&
        field.type === "List All" &&
        (!group_fields || isInGroup(group_fields, field.name)))
    ) {
      const rect = new fabric.Rect({
        id: "square",
        groupName: groupName,
        order: parseInt(options["Order"]),
        top: parseInt(options["Y"]),
        left: canvas_data[id].spacingFieldPosition[field.name]
          ? canvas_data[id].spacingFieldPosition[field.name].x
          : parseInt(options["X"]),
        width: parseInt(options["Width"]),
        height: parseInt(options["Height"]),
        stroke: "#ffffff",
        strokeWidth: 10,
        fill: "rgba(0,0,0,0)",
        selectable: false,
        evented: false,
        visible
      });
      
      let group_x = 0;
      let group_y = 0;
      
      if (groupName && canvas_data[id].smartObjCoords[groupName]) {
        group_x = parseInt(canvas_data[id].smartObjCoords[groupName]["X"]);
        group_y = parseInt(canvas_data[id].smartObjCoords[groupName]["Y"]);
      }
      
      rect.set({
        left: rect.left + group_x - dimension[2] + dimension[4].x, 
        top: rect.top + group_y - dimension[3] + dimension[4].y
      });
      
      canvas.add(rect);
    }
    
    if (
      field.type === "List Numbered Square" ||
      field.type === "List Numbered Circle" ||
      ((list_type === "circle" || list_type === "square") &&
        field.type === "List All" &&
        (!group_fields || isInGroup(group_fields, field.name)))
    ) {
      const text = new fabric.Textbox(options["Option1"], {
        id: "list",
        groupName: groupName,
        order: parseInt(options["Order"]),
        top: parseInt(options["Y"]) + 5,
        left: canvas_data[id].spacingFieldPosition[field.name]
          ? canvas_data[id].spacingFieldPosition[field.name].x
          : parseInt(options["X"]) + 5,
        width: parseInt(options["Width"]),
        fontSize: parseInt(options["Font Size"]),
        fill: "#ffffff",
        fontFamily: "Proxima-Nova-Semibold",
        textAlign: "center",
        selectable: false,
        evented: false,
        visible
      });
      
      text.top += (parseInt(options["Height"]) - text.height) / 2;
      let group_x = 0;
      let group_y = 0;
      
      if (groupName && canvas_data[id].smartObjCoords[groupName]) {
        group_x = parseInt(canvas_data[id].smartObjCoords[groupName]["X"]);
        group_y = parseInt(canvas_data[id].smartObjCoords[groupName]["Y"]);
      }
      
      text.set({ left: text.left + group_x - dimension[2] + dimension[4].x });
      text.set({ top: text.top + group_y - dimension[3] + dimension[4].y });
      
      canvas.add(text);
    } else if (
      field.type === "List Checkmark" ||
      (list_type === "checkmark" &&
        field.type === "List All" &&
        (!group_fields || isInGroup(group_fields, field.name)))
    ) {
      let text = new fabric.Textbox("✓", {
        id: "list",
        groupName: groupName,
        order: parseInt(options["Order"]),
        top: parseInt(options["Y"]) + 10,
        left: canvas_data[id].spacingFieldPosition[field.name]
          ? canvas_data[id].spacingFieldPosition[field.name].x
          : parseInt(options["X"]) + 5,
        width: parseInt(options["Width"]),
        fontSize: parseInt(options["Font Size"]),
        fill: "#ffffff",
        fontFamily: "ARIALUNI",
        textAlign: "center",
        selectable: false,
        evented: false,
        visible
      });
      
      text.top += (parseInt(options["Height"]) - text.height) / 2;
      
      let group_x = 0;
      let group_y = 0;
      
      if (groupName && canvas_data[id].smartObjCoords[groupName]) {
        group_x = parseInt(canvas_data[id].smartObjCoords[groupName]["X"]);
        group_y = parseInt(canvas_data[id].smartObjCoords[groupName]["Y"]);
      }
      
      text.set({
        left: text.left + group_x - dimension[2] + dimension[4].x,
        top: text.top + group_y - dimension[3] + dimension[4].y
      });
      
      canvas.add(text);
    } else if (
      field.type === "List Star" ||
      (list_type === "star" &&
        field.type === "List All" &&
        (!group_fields || isInGroup(group_fields, field.name)))
    ) {
      const text = new fabric.Textbox("★", {
        id: "list",
        groupName: groupName,
        order: parseInt(options["Order"]),
        top: parseInt(options["Y"]) + 5,
        left: canvas_data[id].spacingFieldPosition[field.name]
          ? canvas_data[id].spacingFieldPosition[field.name].x
          : parseInt(options["X"]) + 5,
        width: parseInt(options["Width"]),
        fontSize: parseInt(options["Font Size"]),
        fill: "#ffffff",
        fontFamily: "ARIALUNI",
        textAlign: "center",
        selectable: false,
        evented: false,
        visible
      });
      
      text.top += (parseInt(options["Height"]) - text.height) / 2;
      let group_x = 0;
      let group_y = 0;
      
      if (groupName && canvas_data[id].smartObjCoords[groupName]) {
        group_x = parseInt(canvas_data[id].smartObjCoords[groupName]["X"]);
        group_y = parseInt(canvas_data[id].smartObjCoords[groupName]["Y"]);
      }
      
      text.set({ left: text.left + group_x - dimension[2] + dimension[4].x });
      text.set({ top: text.top + group_y - dimension[3] + dimension[4].y });
      
      canvas.add(text);
    }
  });
}
